import api from '@/services/api'

export const evaluateGoal = async (targetId, params) => {
    try {
        return await api.post(`/goals/${targetId}/checkins`, params)
    } catch (e) {
        console.log(e)
    }
}

export const getRangesFromAPI = async () => {
    try {
        const resp = await api.get('/ranges', {
            params: {
                all: 1,
                ascending: 1,
                orderBy: 'order',
            },
        })
        return await resp.data.data.data
    } catch (e) {
        console.log(e)
    }
}

export const getGoalRangesFromAPI = async goalId => {
    try {
        const resp = await api.get(`/goals/${goalId}`)
        return await resp.data.data.ranges
    } catch (e) {
        console.log(e)
    }
}
